/**
 * Highlight selected node path i.e. from and to directions
 */
export function highlightPath(d, nodes) {
	document.querySelectorAll(".lineage-highlight").forEach(el => {
		el.classList.remove("lineage-highlight");
	});
	/**
	 * Add lowlight class to all eligible elements
	 */
	document.querySelectorAll(".node,.link,.link-arrow,.pagination-footer-wrapper").forEach(el => {
		el.classList.add("lineage-lowlight");
	});

	const highlightFrom = id => {
		const nodeInDom = document.querySelector(`#${id}`);
		if (nodeInDom) {
			nodeInDom.classList.remove("lineage-lowlight");
		}
		/**
		 * Highlight pagination footer
		 */
		const paginationBarInDom = document.querySelector(`#${id}-pagination-footer`);
		if (paginationBarInDom) {
			paginationBarInDom.classList.remove("lineage-lowlight");
		}
		/**
		 * Highlight child nodes
		 */
		const childs = document.querySelectorAll(`.child-node-${id}`);
		if (childs) {
			childs.forEach(el => {
				el.classList.remove("lineage-lowlight");
			});
		}
		document.querySelectorAll(`[id^="${id}->"]`).forEach(el => {
			el.classList.add("lineage-highlight");
			el.classList.remove("lineage-lowlight");
			const fromid = el.getAttribute("id").split("->")[1];
			highlightFrom(fromid);
		});
	};
	const highlightTo = id => {
		const nodeInDom = document.querySelector(`#${id}`);
		if (nodeInDom) {
			nodeInDom.classList.remove("lineage-lowlight");
		}
		/**
		 * Highlight pagination footer
		 */
		const paginationBarInDom = document.querySelector(`#${id}-pagination-footer`);
		if (paginationBarInDom) {
			paginationBarInDom.classList.remove("lineage-lowlight");
		}
		/**
		 * Highlight child nodes
		 */
		const childs = document.querySelectorAll(`.child-node-${id}`);
		if (childs) {
			childs.forEach(el => {
				el.classList.remove("lineage-lowlight");
			});
		}

		document.querySelectorAll(`[id$="->${id}"],[id$="->${id}~arrow"]`).forEach(el => {
			el.classList.add("lineage-highlight");
			el.classList.remove("lineage-lowlight");
			const fromid = el.getAttribute("id").split("->")[0];
			highlightTo(fromid);
		});
	};
	/**
	 * Highlight node based on name
	 */
	const nodesToHighlight = nodes.filter(n => n.name === d.name);

	if (nodesToHighlight) {
		nodesToHighlight.forEach(n => {
			highlightFrom(n.id);
			highlightTo(n.id);
		});
	}
}

/**
 * Remove highlighted node path
 */
export function removeHighlight() {
	document.querySelectorAll(".lineage-highlight").forEach(el => {
		el.classList.remove("lineage-highlight");
	});
	document.querySelectorAll(".lineage-lowlight").forEach(el => {
		el.classList.remove("lineage-lowlight");
	});
}
